import { PlaceSelector as PlaceSelectorComponent } from '@/ui';
import { getChannel, getDocument } from '@lib/server';
import { Aggregator, Place } from '@types';

import { BlockBase } from './utils';

export async function PlaceSelector({
  params,
  id,
  ...data
}: {
  places: Array<{ id: string }>;
  actionUrl: string;
} & BlockBase) {
  if (!data.places?.length) {
    return null;
  }

  let places = [];

  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel?.channelId) {
    return null;
  }

  const brand = await getDocument<Aggregator>('brand', channel.micrositeData?.[0]?.id, {
    select: ['fields.venuesPageSlug', 'fields.name'],
    tags: [channel.channelId],
    depth: 0,
  });

  const venuesPageSlug = brand?.fields?.venuesPageSlug || 'bars';

  for (const place of data.places) {
    const { fields } = await getDocument<Place>('places', place.id, {
      tags: [channel.channelId],
      depth: 0,
      status: 'published',
      select: ['fields.custom.displayName', 'fields.custom.slug'],
    });
    places.push(fields);
  }

  if (!places) {
    return null;
  }

  return (
    <div id={id}>
      <PlaceSelectorComponent places={places} actionUrl={data.actionUrl} venuesPageSlug={venuesPageSlug} />
    </div>
  );
}
